import { render, staticRenderFns } from "./_threeClass.vue?vue&type=template&id=d8707f7e&scoped=true"
import script from "./_threeClass.vue?vue&type=script&lang=js"
export * from "./_threeClass.vue?vue&type=script&lang=js"
import style0 from "./_threeClass.vue?vue&type=style&index=0&id=d8707f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8707f7e",
  null
  
)

export default component.exports